module.exports = __webpack_public_path__ + "img/confetti.0cc476c2.png";